import z from "zod";
import { OrganizationIdSchema, ProjectIdSchema, WorkspaceIdSchema } from "./idTypes";

export const TenancySchema = z.object({
  tenantId: OrganizationIdSchema,
  organizationId: OrganizationIdSchema,
  workspaceId: WorkspaceIdSchema,
  projectId: ProjectIdSchema,
});
export type Tenancy = z.infer<typeof TenancySchema>;
